import './assets/css/index.css'
import { createApp } from './app'

const { app, router } = createApp()
// wait until page component is fetched before mounting
router.isReady().then(() => {
  // app.mount('#app')
  app.mount('#app', true)
})
